import EmojiRatingPage from "@components/EmojiRatingPage"

export default function LooksmaxxingBoldLooksPage() {
  return (
    <EmojiRatingPage
      translationKey="boldLooksLooksmaxxing"
      leftLabelKey="playItSafe"
      rightLabelKey="superBold"
    />
  )
}
